import { Link } from 'react-router';

import { Icon } from '@/components/ui/icon';

export interface Crumb {
  label: string;
  /** Omit on the final crumb, which represents the current page. */
  to?: string;
}

export function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-2">
      <ol className="flex flex-wrap items-center gap-1 text-xs text-content-muted">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            /* Keyed by position, not by label. Two crumbs reading the same
               thing - which happens while two records are still loading and
               both show a placeholder - were duplicate keys, and React kept
               the stale one for the rest of the visit: a trail one crumb
               longer than the page it described. A trail is an ordered list
               whose entries have no identity of their own, which is exactly
               when the index is the right key. */
            <li key={index} className="flex items-center gap-1">
              {item.to && !isLast ? (
                <Link to={item.to} className="transition-colors hover:text-content">
                  {item.label}
                </Link>
              ) : (
                <span
                  className="font-medium text-content"
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}

              {!isLast && <Icon name="chevron-right" size={12} className="text-content-subtle" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
